namespace advisorop.components.meetinghub {

    export class MeetingListController {
        public meetings: Array<domains.IMeeting>;
        public dgMeetingOptions: DevExpress.ui.dxDataGridOptions;
        public participantURL: string;

        constructor(private meetingHubService: services.MeetingHubService,
            private generalService: services.GeneralService,
            private copyToClipboard: services.CopyToClipboard,
            private ids: services.IdentityService, private $location: ng.ILocationService) {

            this.dgMeetingOptions = {
                export: {
                    enabled: true,
                    fileName: `meetings`
                },
                bindingOptions: {
                    dataSource: `vm.meetings`
                },
                scrolling: {
                    mode: `standard`,
                    useNative: true
                },
                //height: `350px`,
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                stateStoring: {
                    enabled: true,
                    type: `localStorage`,
                    storageKey: `dgMeetingOptions`
                },
                columnChooser: {
                    enabled: true,
                    title: `Select columns`
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                noDataText: `No Meetings`,
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'id', visible: false },
                    { dataField: 'title', caption: 'Title', width: 120},
                    {
                        dataField: 'startDate', caption: 'Start Date', visible: true, dataType: 'date', format: 'MM/dd/yy hh:mm a', width: 105,
                        allowSorting: true, allowFiltering: true,
                    },
                    {
                        dataField: 'endDate', caption: 'End Date', visible: true, dataType: 'date', format: 'MM/dd/yy hh:mm a', width: 105,
                        allowSorting: true, allowFiltering: true,
                    },
                    {
                        dataField: 'type', caption: 'Type', calculateDisplayValue: rowData => {
                            var meetingType = "";

                            switch (rowData.type) {
                                case domains.MeetingType.IN_PERSON:
                                    meetingType = "In Person";
                                    break;
                                case domains.MeetingType.PHONE:
                                    meetingType = "Phone";
                                    break;
                                case domains.MeetingType.VIDEO:
                                    meetingType = "Video";
                                    break;
                            }
                            return meetingType;
                        }
                    },
                    {
                        dataField: 'household.name', caption: 'Household'
                    },
                    {
                        dataField: 'advisor.fullName', caption: 'Advisor'
                    }
                ],
                masterDetail: {
                    enabled: true,
                    template: 'participants'
                },
                selection: {
                    mode: 'single',
                    showCheckBoxesMode: 'onClick'
                },
                onSelectionChanged: function (selectedItems) {
                    var data = selectedItems.selectedRowsData[0];
                    if (data) {
                        this.onMeetingChanged({ id: data.id });
                    }
                },
            };
        }

        getParticipantsGridSettings(meeting: domains.IMeeting): DevExpress.ui.dxDataGridOptions {
            var absUrl = this.$location.absUrl();
            var path = this.$location.path();
            var indexOfPath = absUrl.indexOf(path);
            var path = (meeting.status == domains.MeetingStatus.SCHEDULED ? "/meetinghub/meeting/" : "/meetinghub/meeting/scheduler/");
            this.participantURL = absUrl.substring(0, indexOfPath) + path + meeting.guid + "/";
            var dgParticipantsOptions: DevExpress.ui.dxDataGridOptions = {
                dataSource: meeting.participants,
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                stateStoring: {
                    enabled: true,
                    type: `localStorage`,
                    storageKey: `dgMeetingParticipantOptions`
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                noDataText: `No Meeting Participants`,
                columns: [
                    { dataField: "name" },
                    {
                        caption: "Meeting URL", calculateCellValue: e => {
                            var url = this.participantURL + e.guid;
                            return url;
                        }
                    },
                    { dataField: 'id', caption: '', cellTemplate: 'btnActions' }
                ],
            };
            return dgParticipantsOptions;
        }

        canEmail(participant: domains.IMeetingParticipant): boolean {
            return true;
        }

        sendEmailToParticipant(participant: domains.IMeetingParticipant, meeting: domains.IMeeting): void {
            this.meetingHubService.emailParticipant(participant.id, meeting).then(resp => {
                toastr.success(`The meeting link was emailed to ${participant.name}`, "Email Sent");
            }).catch(err => {
                toastr.error(err);
            })
        }

        getParticipantLink(participant: domains.IMeetingParticipant): void {
            var link = this.participantURL + participant.guid;
            this.copyToClipboard.copy(link).then(resp => {
                toastr.success("Meeting link copied to clipboard.");
            }).catch(err => {
                toastr.error(`Failed to copy link - ${err}`);
            })
        }

        onMeetingChanged(id: number): void {
            console.log("Meeting " + id + "selected.")
        }

        $onInit(): void {
        }

    }

    class MeetingList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                meetings: '<'
            };
            this.controller = [`meetingHubService`, `generalService`, `copyToClipboard`, `identityService`, `$location`, MeetingListController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/meeting-list.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingList`, new MeetingList());

}